import axios from "../../utils/Axios";

export const getAllJobs = async () => {
    const response = await axios.get('/jobs');
    return response.data;
}